/**
 * #######################################################@
 *
 * Other settings
 *
 * #######################################################@
 */
import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";

import {
	Card,
	CardContent,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	Icon
} from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import SettingsActions from "redux-react/actions/settingsActions";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import MDTypography from "components/Basics/MDTypography";
import { useState } from "react";
import i18n from "i18n";
import { display } from "redux-react/reducers/snackBarReducer";
import FormDictionary from "./Dictionary/FormDictionary";
import FAIQMigrationDialog from "./FAIQMigrationDialog";
import FAIQDeleteCollectionDialog from "./FAIQDeleteCollectionDialog";

const GetCorrectForm = ({ type, submit }) => {
	switch (type) {
		case "dictionary":
			return <FormDictionary submit={submit} />;
		default:
			return <DialogContent>Not found</DialogContent>;
	}
};

const AddChartEnyity = ({ icon, text, type }) => {
	const [open, setOpen] = useState(false);
	const [isValid, setIsValid] = useState(false);
	const [datas, setDatas] = useState({});
	const dispatch = useDispatch();
	const { user } = useSelector(state => state);

	const submit = ({ valid, data }) => {
		setDatas(data);
		setIsValid(valid);
	};

	const clickSubmit = () => {
		switch (type) {
			case "dictionary":
				dispatch(
					SettingsActions.insertDictionary(
						user.accountID,
						datas,
						e => {
							dispatch(
								display({
									type: "success",
									message: i18n.t("SETTINGS.DICTIONARY.CALL.successCreate")
								})
							);
							setOpen(false);
						},
						e => {
							let message = e?.response?.data?.error?.message;
							dispatch(
								display({
									type: "error",
									message: i18n.t(`SETTINGS.DICTIONARY.CALL.${message || "errorCreate"}`)
								})
							);
						}
					)
				);
				break;
			default:
				break;
		}
	};

	return (
		<>
			<MDButton color="info" onClick={() => setOpen(true)}>
				<Icon>{icon}</Icon>&nbsp;{text}
			</MDButton>
			<Dialog fullWidth maxWidth="md" open={open} onClose={() => setOpen(false)}>
				<DialogContent>
					<GetCorrectForm type={type} submit={submit} />
				</DialogContent>
				<DialogActions>
					<MDButton variant="outlined" color="dark" onClick={() => setOpen(false)}>
						{i18n.t("SETTINGS.cancel")}
					</MDButton>

					<MDButton variant="contained" color="dark" onClick={clickSubmit} disabled={!isValid}>
						{i18n.t("SETTINGS.add")}
					</MDButton>
				</DialogActions>
			</Dialog>
		</>
	);
};

const FAIQActionCard = ({
	icon,
	title,
	description,
	buttonText,
	buttonColor,
	onClick,
	variant = "contained"
}) => (
	<MDBox
		borderRadius="lg"
		border="1px solid"
		borderColor="grey.200"
		p={2}
		display="flex"
		flexDirection="column"
		justifyContent="space-between"
		minHeight="180px"
		bgcolor="background.paper"
	>
		<MDBox display="flex" alignItems="center" gap={1} mb={1}>
			<Icon>{icon}</Icon>
			<MDTypography variant="button" fontWeight="medium">
				{title}
			</MDTypography>
		</MDBox>
		<MDTypography variant="caption" color="text">
			{description}
		</MDTypography>
		<MDBox mt={3}>
			<MDButton variant={variant} color={buttonColor} onClick={onClick} fullWidth>
				{buttonText}
			</MDButton>
		</MDBox>
	</MDBox>
);

export default function SettingsOthers({ route }) {
	const [migrationOpen, setMigrationOpen] = useState(false);
	const [deleteOpen, setDeleteOpen] = useState(false);
	const [copyOpen, setCopyOpen] = useState(false);

	return (
		<DashboardLayout>
			<DashboardNavbar filters={[]} />
			<Divider />
			<Card>
				<CardContent>
					<MDTypography variant="h5" fontWeight="medium" gap={2}>
						{i18n.t("SETTINGS.OTHERS.moreSettings")}
					</MDTypography>
					<MDBox display="flex" alignItems="center">
						<MDBox m={1}>
							<AddChartEnyity
								icon="add"
								text={i18n.t("SETTINGS.DICTIONARY.addDictionary")}
								type="dictionary"
							/>
						</MDBox>
					</MDBox>

					<Divider />

					<MDBox display="flex" flexDirection="column" gap={2}>
						<MDBox>
							<MDTypography variant="h5" fontWeight="medium">
								{i18n.t("SETTINGS.OTHERS.faiqOperationsTitle")}
							</MDTypography>
							<MDTypography variant="body2" color="text">
								{i18n.t("SETTINGS.OTHERS.faiqOperationsDescription")}
							</MDTypography>
						</MDBox>
						<MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr" }} gap={2}>
							<FAIQActionCard
								icon="swap_horiz"
								title={i18n.t("SETTINGS.OTHERS.migrateTitle")}
								description={i18n.t("SETTINGS.OTHERS.migrateDescription")}
								buttonText={i18n.t("SETTINGS.OTHERS.migrateButton")}
								buttonColor="info"
								onClick={() => setMigrationOpen(true)}
							/>
							<FAIQActionCard
								icon="content_copy"
								title={i18n.t("SETTINGS.OTHERS.copyTitle")}
								description={i18n.t("SETTINGS.OTHERS.copyDescription")}
								buttonText={i18n.t("SETTINGS.OTHERS.copyButton")}
								buttonColor="info"
								variant="outlined"
								onClick={() => setCopyOpen(true)}
							/>
							<FAIQActionCard
								icon="delete"
								title={i18n.t("SETTINGS.OTHERS.deleteTitle")}
								description={i18n.t("SETTINGS.OTHERS.deleteDescription")}
								buttonText={i18n.t("SETTINGS.OTHERS.deleteButton")}
								buttonColor="error"
								onClick={() => setDeleteOpen(true)}
							/>
						</MDBox>
						<MDTypography variant="caption" color="text">
							{i18n.t("SETTINGS.OTHERS.faiqOperationsNote")}
						</MDTypography>
					</MDBox>
				</CardContent>
			</Card>
			<FAIQMigrationDialog open={migrationOpen} onClose={() => setMigrationOpen(false)} />
			<FAIQDeleteCollectionDialog open={deleteOpen} onClose={() => setDeleteOpen(false)} />
			<FAIQMigrationDialog isCopy open={copyOpen} onClose={() => setCopyOpen(false)} />
		</DashboardLayout>
	);
}
